// Central visibility for legacy readers that intentionally return null on error.
// Retain their API contract without presenting a failed load as financial zero.
const listeners = new Set();
let failures = new Map();
const latestRequest = new Map();
const requestPath = config => new URL(config.url, window.location.origin).pathname;
export const beginRead = config => {
  if (config.method?.toLowerCase() !== "get") return;
  const key = `${config._readScope}:${requestPath(config)}`;
  latestRequest.set(key, Math.max(latestRequest.get(key) || 0, config._readStartedAt));
};
export const readScope = () => window.location.pathname + window.location.search;
export const subscribeReadFailures = callback => { listeners.add(callback); return () => listeners.delete(callback); };
export const getReadFailures = () => failures;
export const resetReadFailures = scope => {
  failures = new Map([...failures].filter(([, value]) => value.scope !== scope));
  listeners.forEach(callback => callback());
};
export const reportReadResult = (config, error) => {
  if (!config?._readScope || config.method?.toLowerCase() !== "get") return;
  const path = requestPath(config);
  if (config._readStartedAt < latestRequest.get(`${config._readScope}:${path}`)) return;
  if (config._readOptional && error) return;
  if (/\/api\/(auth|supply-scanner|ip)(\/|$)/.test(path)) return;
  if (error?.code === "ERR_CANCELED" || error?.response?.status === 401) return;
  const key = `${config._readScope}:${path}:${JSON.stringify(config.params || {})}`;
  failures = new Map(failures);
  if (error) failures.set(key, { scope: config._readScope, path, started: config._readStartedAt });
  else {
    for (const [id, value] of failures) {
      if (value.scope === config._readScope && value.path === path && value.started <= config._readStartedAt) failures.delete(id);
    }
  }
  listeners.forEach(callback => callback());
};